<!--
 * @Author: your name
 * @Date: 2022-04-02 15:41:21
 * @LastEditTime: 2022-04-22 16:08:41
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \mingyao\src\views\News.vue
-->
<template>
  <div>
    <div class="news">
      <div
        class="news-list"
        v-for="i in 10"
        :key="i"
        :class="news[(currentPage - 1) * 10 + (i - 1)] ? 'new' : 'no-new'"
      >
        <template v-if="news[(currentPage - 1) * 10 + (i - 1)]">
          <div
            class="news-img"
            :style="calcStyle(news[(currentPage - 1) * 10 + (i - 1)])"
          ></div>
          <div class="news-content">
            <div class="news-tit">
              {{ news[(currentPage - 1) * 10 + (i - 1)].title }}
            </div>
            <div class="news-prev">
              {{
                (
                  news[(currentPage - 1) * 10 + (i - 1)].preview ||
                  (news[(currentPage - 1) * 10 + (i - 1)].content &&
                    news[(currentPage - 1) * 10 + (i - 1)].content[0]) ||
                  ""
                ).substr(0, 100) + "..."
              }}
            </div>
            <div class="time">
              {{ news[(currentPage - 1) * 10 + (i - 1)].time || "" }}
            </div>
            <div
              class="detail"
              @click="
                () => {
                  currentNew = news[(currentPage - 1) * 10 + (i - 1)];
                }
              "
            >
              详情
            </div>
          </div>
        </template>
      </div>
    </div>
    <div class="page-split">
      <div
        :class="(currentPage == 1 ? 'fob' : '') + ' prev'"
        @click="changePage(-1)"
      >
        上一页
      </div>
      <div>跳转到</div>
      <input :value="currentPage" type="number" />
      <div
        :class="
          (currentPage == Math.ceil(news.length / 10) ? 'fob' : '') + ' next'
        "
        @click="changePage(1)"
      >
        下一页
      </div>
    </div>
    <div class="news-detail" v-if="currentNew">
      <div class="news-title-text">{{ currentNew.title }}</div>
      <div class="news-time-text">{{ currentNew.time }}</div>
      <template v-if="currentNew.pictures">
        <img
          v-for="v in currentNew.pictures"
          :src="'./images/' + v"
          :key="'pic'+v"
          :class="
            currentNew.pictures && currentNew.pictures.length == 1
              ? 'single'
              : 'multi'
          "
        />
      </template>
      <template v-if="currentNew.videos">
        <video
          controls="controls"
          autoplay
          muted
          v-for="v in currentNew.videos"
          :src="'./images/' + v"
          :key="'vid'+v"
        >
          your browser does not support the video tag
        </video>
      </template>
      <div class="news-content-text">
        <p v-for="v in currentNew.content" :key="v">{{ v }}</p>
      </div>
      <div
        class="close"
        @click="
          () => {
            currentNew = null;
          }
        "
      >
        返回
      </div>
    </div>
    <Root />
  </div>
</template>

<script>
import Root from "../components/Root.vue";
import axios from "axios";
export default {
  name: "News",
  components: {
    Root,
  },
  data: () => {
    return {
      news: [],
      currentPage: 1,
      currentNew: null,
    };
  },
  mounted() {
    this.init();
  },
  computed: {
    calcStyle() {
      return (v) => {
        let jpg = v.titlePic || (v.pictures && v.pictures[0]) || "no-image.jpg";
        return {
          backgroundImage: "url(/images/" + jpg + ")",
        };
      };
    },
  },
  methods: {
    changePage(v) {
      let a = this.currentPage + v;
      if (a < 1 || a > Math.ceil(this.news.length / 10)) {
        return;
      }
      this.currentPage = a;
    },
    init() {
      let _this = this;
      axios.get("../news.json").then((res) => {
        _this.news = res.data || [];
        console.log(res);
      });
    },
  },
};
</script>

<style lang="less" scoped>
.no-new {
  display: none;
}
.news {
  padding: 1rem 20%;
  min-height: 100%;
  text-align: left;
}
.news-list.no-new {
  display: none;
}
.news-list {
  width: calc(50% - 1rem);
  margin: 0.5rem;
  display: inline-block;
  padding: 1rem;
  border-bottom: 1px solid rgb(233, 233, 233);
  .news-img {
    width: 9.5rem;
    height: 10rem;
    margin-right: 0.5rem;
    float: left;
  }
  .news-content {
    text-align: left;
    width: calc(100% - 10rem);
    float: left;
    .news-tit {
      font-size: 1.25rem;
      color: rgb(27, 151, 243);
      border-left: 5px solid rgb(27, 151, 243);
      padding-left: 0.5rem;
      font-weight: bold;
      text-align: left;
      margin-bottom: 0.5rem;
    }
    .news-prev {
      font-size: 0.9rem;
      color: rgb(100, 100, 100);
      min-height: 5rem;
    }
    .time {
      display: inline-block;
      float: left;
      font-size: 0.9rem;
      color: rgb(100, 100, 100);
      margin-top: 0.5rem;
    }
    .detail {
      font-size: 0.9rem;
      color: rgb(100, 100, 100);
      cursor: pointer;
      opacity: 0.9;
      margin-top: 0.5rem;
      float: right;
      display: inline-block;
      text-decoration: underline;
    }
    .detail:hover {
      cursor: pointer;
      opacity: 1;
    }
  }
}
.page-split {
  text-align: center;
  div,
  input {
    display: inline-block;
  }
  input {
    width: 3rem;
  }
  .prev,
  .next {
    margin: 0 0.5rem;
    text-decoration: underline;
    cursor: pointer;
  }
  .prev:hover,
  .next:hover {
    color: #42b983;
    cursor: pointer;
  }
  .fob:hover,
  .fob {
    cursor: not-allowed !important;
  }
}
.news-detail {
  position: fixed;
  width: 100%;
  height: calc(100% - 6rem);
  top: 6.05rem;
  z-index: 99;
  background-color: white;
  padding: 1rem 20%;
  overflow: auto;
  .single {
    width: 100%;
  }
  .multi {
    width: calc(50% - 1rem);
    margin: 0.5rem;
  }
  .news-title-text {
    font-size: 1.5rem;
    color: rgb(27, 151, 243);
    margin-bottom: 1rem;
  }
  .news-time-text {
    font-size: 0.9rem;
    color: rgb(200, 200, 200);
  }
  .news-content-text {
    text-align: left;
    p {
      text-indent: 2rem;
      font-size: 1rem;
      line-height: 1.5rem;
      color: rgb(100, 100, 100);
    }
  }
  .close {
    position: fixed;
    top: 8rem;
    right: 15%;
    text-decoration: underline;
    cursor: pointer;
  }
}
</style>